<template>
	<Card :title="offer.title" :subtitle="`$ ${formatNumber(offer.price, 2, trans('general.number.decimal'), trans('general.number.thousands'))}`">
		<template #badges>
			<Badge v-if="showAvailability" :color="Color.Blue" active>{{ transChoice('enrollments.bundles.create.available', offer.available) }}</Badge>
			<Badge v-else :color="Color.Blue" active>{{ trans('enrollments.bundles.create.limited') }}</Badge>
			<i v-if="isSelected" class="fa-solid fa-check-circle text-slate-500 dark:text-slate-600 text-2xl cursor-pointer" @click.stop="emit('selected', offer)"/>
			<i v-else class="fa-regular fa-circle text-gray-400 dark:text-slate-600 text-2xl cursor-pointer" @click.stop="emit('selected', offer)"/>
		</template>
		<div v-if="offer.description" class="wysiwyg-content" v-html="offer.description"/>
	</Card>
</template>
<script setup lang="ts">
import {formatNumber} from '@/helpers'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import Badge from '@/Components/Badges/Badge.vue'
import {trans, transChoice} from 'laravel-vue-i18n'
import {type Offer} from '@/Types/Events/Bundles/Offers/Offer'
import {computed, type ComputedRef, defineEmits, defineProps, type Ref, ref} from 'vue'

const props = defineProps<{
	offer:Offer,
	showAvailability:boolean,
	selectedOffers:Array<Offer>,
}>()

const emit = defineEmits([
	'selected',
])

const offer:Ref<Offer> = ref(props.offer)
const selectedOffers:Ref<Array<Offer>> = ref(props.selectedOffers)

const isSelected:ComputedRef<boolean> = computed(():boolean => {
	return selectedOffers.value.findIndex((o:Offer) => o.id === offer.value.id) > -1
})
</script>